import { MigrationType } from "./Statistics/MigrationType";

/** How many Not Found files one type has across the organization, and across how many parents. */
export interface NotFoundRetryCount {
  migrationType: MigrationType;
  fileCount: number;
  entityCount: number;
}

/** The types an org-wide retry can cover, in the order the portal lists them. */
export const NOT_FOUND_RETRY_TYPES: MigrationType[] = [
  MigrationType.CasesMigration,
  MigrationType.IntakesMigration,
  MigrationType.ProvidersMigration,
  MigrationType.FirmDocumentsMigration,
  MigrationType.TemplatesMigration,
];
